var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHistory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 8H17.3333C18.0667 8 18.6667 7.4 18.6667 6.66667C18.6667 5.93333 18.0667 5.33333 17.3333 5.33333H12C11.2667 5.33333 10.6667 5.93333 10.6667 6.66667C10.6667 7.4 11.2667 8 12 8ZM12 13.3333H17.3333C18.0667 13.3333 18.6667 12.7333 18.6667 12C18.6667 11.2667 18.0667 10.6667 17.3333 10.6667H12C11.2667 10.6667 10.6667 11.2667 10.6667 12C10.6667 12.7333 11.2667 13.3333 12 13.3333ZM12 18.6667H17.3333C18.0667 18.6667 18.6667 18.0667 18.6667 17.3333C18.6667 16.6 18.0667 16 17.3333 16H12C11.2667 16 10.6667 16.6 10.6667 17.3333C10.6667 18.0667 11.2667 18.6667 12 18.6667ZM5.33333 5.33333H8V8H5.33333V5.33333ZM5.33333 10.6667H8V13.3333H5.33333V10.6667ZM5.33333 16H8V18.6667H5.33333V16ZM22.6667 0H1.33333C0.6 0 0 0.6 0 1.33333V22.6667C0 23.4 0.6 24 1.33333 24H22.6667C23.4 24 24 23.4 24 22.6667V1.33333C24 0.6 23.4 0 22.6667 0ZM21.3333 21.3333H2.66667V2.66667H21.3333V21.3333Z",
    fill: "#2541B2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.344d9736fd9fdbecd40a3e0041c4da37.svg";
export { ForwardRef as ReactComponent };